import { appConfig } from '@/config/app.ts'

export interface CampaignState {
  isLoading: boolean
  isCreateModalOpen: boolean
  editId: number | null
  filters: string
}

export const initialState: CampaignState = {
  isLoading: false,
  isCreateModalOpen: false,
  editId: null,
  filters: `?limit=${appConfig.pagination.defaultValue}`
}
